//
//
//
//

import { mapActions } from 'vuex';

export default {
  data() {
    return {
      ready: false,
    };
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.loadP2pCurrencies(),
      this.loadP2pPaymentMethods(),
    ]);
    this.setGeneralLoader(false);

    this.ready = true;
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    ...mapActions('p2p', ['loadP2pCurrencies', 'loadP2pPaymentMethods']),
  },
};
